module.exports = __webpack_public_path__ + "static/img/user.1ab23420.png";